import React from 'react'
import Video from "../../../assets/images/video-1.jpg"
import Icon8 from "../../../assets/images/icon-8.png"
import Icon9 from "../../../assets/images/icon-9.png"
import Icon10 from "../../../assets/images/icon-10.png"
import Icon3 from "../../../assets/images/icon-3-corrected.png"
import Shape20 from "../../../assets/images/shape-20.png"
import Shape21 from "../../../assets/images/shape-21.png"
import Shape19 from "../../../assets/images/shape-19.png"
import { config } from '../config'

const Process = () => {
    return (
        <div>
            <section className="process-section">
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="col-lg-6 col-md-12 col-sm-12 left-column">
                            <div className="inner-box">
                                <div className="shape" style={{ backgroundImage: `url(${Shape19})` }}></div>
                                <div className="sec-title">
                                    <h2>Learn to Drive in 3 Simple Steps</h2>
                                    <p>Starting your driving journey doesn't have to be complicated. At Precision Driving School, we make learning simple with structured lessons, experienced instructors and personalised guidance every step of the way.</p>
                                </div>
                                <div className="image-box">
                                    <figure className="image"><img src={Video} alt="Journey to Mastery Image" /></figure>
                                    <div className="video-btn">
                                        <a href="https://www.youtube.com/watch?v=nfP5N9Yc72A&amp;t=28s" className="lightbox-image" data-caption=""><i className="flaticon-play-button-1"></i></a>
                                    </div>
                                </div>
                                <div className="single-item">
                                    <div className="icon"><img src={Icon8} alt="Card Icon" /></div>
                                    <h3>Get Your First <br />Free Online Lesson Today!</h3>
                                    <p>Schedule your class at your convenience.<a href={`${config.appUrl}book-a-lesson`}><i className="flaticon-right-arrow-1"></i>Schedule Now</a></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 right-column">
                            <div className="inner-box">
                                <div className="single-item">
                                    <div className="arrow-shape" style={{ backgroundImage: `url(${Shape20})` }}></div>
                                    <span className="count-text">01</span>
                                    <div className="icon"><img src={Icon9} alt="Card Icon" /></div>
                                    <h4><a href="#">Book Your First Lesson</a></h4>
                                    <p>Choose from Automatic, Manual or Intensive Driving Lessons and book a time that suits your schedule.</p>
                                </div>
                                <div className="single-item">
                                    <div className="arrow-shape-2" style={{ backgroundImage: `url(${Shape21})` }}></div>
                                    <span className="count-text">02</span>
                                    <div className="icon"><img src={Icon10} alt="Card Icon" /></div>
                                    <h4><a href="#">Learn with Experienced Instructors</a></h4>
                                    <p>Receive personalised one-to-one tuition from friendly DVSA-approved driving instructors using modern teaching methods.</p>
                                </div>
                                <div className="single-item">
                                    <div className="arrow-shape" style={{ backgroundImage: `url(${Shape20})` }}></div>
                                    <span className="count-text">03</span>
                                    <div className="icon"><img src={Icon3} alt="Card Icon" /></div>
                                    <h4><a href="#">Pass with Confidence</a></h4>
                                    <p>Build safe driving habits, gain real-world experience and prepare confidently for your practical driving test.</p>
                                </div>
                                <div className="btn-box">
                                    <a href={`${config.appUrl}contact-us`} className="theme-btn btn-two">Send Request</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Process
